import type { Translations } from '../../types'

const untrustedMessages: Translations = {
  "untrusted.title": "Dispositivo non riconosciuto",
  "untrusted.description": "Per accedere devi fidare questo dispositivo. Controlla i dettagli e conferma.",
  "untrusted.device": "Dispositivo",
  "untrusted.ip": "IP",
  "untrusted.location": "Località",
  "untrusted.userAgent": "User agent",
  "untrusted.logout": "Esci",
  "untrusted.trust": "Fida dispositivo",
  "untrusted.trusting": "Conferma...",
  "untrusted.unknown": "Sconosciuto"
}

export default untrustedMessages
